import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { fetchTicker } from "@/lib/api";

export default function LiveTicker() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const data = await fetchTicker();
        if (alive) setEvents(data.events || []);
      } catch (e) {
        if (alive) setEvents([]);
      }
    };
    load();
    const t = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!events.length) return null;

  return (
    <div
      data-testid="live-ticker"
      className="border-y border-white/10 bg-[#0A0A0A] py-2.5 overflow-hidden"
    >
      <div className="flex items-center max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 gap-4">
        <div className="flex items-center gap-2 shrink-0 pr-4 border-r border-white/10">
          <span className="live-dot" />
          <span className="font-display text-base tracking-[0.2em] text-volt">LIVE</span>
        </div>
        <Marquee gradient={false} speed={45} pauseOnHover>
          {events.map((ev, i) => (
            <span
              key={i}
              className="mx-8 text-xs uppercase tracking-[0.18em] text-white/80 font-mono"
            >
              {ev}
              <span className="ml-8 text-volt">•</span>
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
